"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const devMsg = require("./lib/devMsg.cjs");
function createLocaleRedirect() {
  throw new Error(`createLocaleRedirect() has been removed due to performance issues. See ${devMsg.devMsg("replace-createLocaleRedirect")} for more details.`);
}
exports.createLocaleRedirect = createLocaleRedirect;
//# sourceMappingURL=createLocaleRedirect.cjs.map
